import { render, staticRenderFns } from "./ArticleSimpleCard.vue?vue&type=template&id=41968b30&scoped=true&"
import script from "./ArticleSimpleCard.vue?vue&type=script&lang=js&"
export * from "./ArticleSimpleCard.vue?vue&type=script&lang=js&"
import style0 from "./ArticleSimpleCard.vue?vue&type=style&index=0&id=41968b30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41968b30",
  null
  
)

export default component.exports